import React, { useContext } from "react"
import { useWatch } from "react-hook-form"

import classNames from "classnames"

import { InputContext } from "shared/ui/input/Input"

import { BooleanInputContext } from "../BooleanInput"

interface ReadonlyBooleanProps
  extends Omit<
    React.PropsWithoutRef<React.HTMLProps<HTMLDivElement>>,
    "value"
  > {
  value?: boolean | null
  render?: (value: boolean) => React.JSX.Element
  showAlways?: boolean
}

export const ReadonlyBoolean = React.memo(
  ({ className, children, render, ...props }: ReadonlyBooleanProps) => {
    const { name } = useContext(InputContext)

    if (name) {
      return <HookFormReadonly {...props} />
    }
    return <Readonly {...props} />
  }
)

const HookFormReadonly = React.memo(
  ({ className, children, render, value, ...props }: ReadonlyBooleanProps) => {
    const { name } = useContext(InputContext)
    const hookFormValue = useWatch({ name }) ?? false

    return <Readonly {...props} value={value ?? hookFormValue} />
  }
)

const Readonly = React.memo(
  ({
    className,
    children,
    render,
    value,
    showAlways,
    ...props
  }: ReadonlyBooleanProps) => {
    const { readonly } = useContext(InputContext)
    const { trueLabel, falseLabel } = useContext(BooleanInputContext)

    if (!readonly && !showAlways) {
      return null
    }

    if (children) {
      return children as React.JSX.Element
    }

    if (typeof value !== "boolean") {
      return null
    }

    if (render) {
      return render(value)
    }

    return (
      <div
        {...props}
        className={classNames(
          "input__value",
          "input__value--readonly",
          className
        )}
      >
        {value ? trueLabel : falseLabel}
      </div>
    )
  }
)
